module.exports = __webpack_public_path__ + "media/เหมียวๆ.f873ec0b.mp3";